import { Box, Select, Text } from 'grommet';
import React from 'react';

export interface PageSizeProps {
  Size: number;
  onChange: (page: string) => void;
}

const PageSize: React.FC<PageSizeProps> = ({ Size, onChange }): JSX.Element => {
  const onChangeOption = (option: { option: string }): void => {
    onChange(option.option);
  };

  return (
    <Box
      fill="horizontal"
      background="background-contrast"
      justify="end"
      align="center"
      pad="small"
      direction="row"
      gap="small"
      height={{
        min: '50px',
      }}
    >
      <Text>
        Page Size
      </Text>
      <Select
        options={['30', '50', '100']}
        value={Size.toString()}
        onChange={onChangeOption}
        a11yTitle="Select page size"
        size="small"
      />
    </Box>
  );
};

PageSize.displayName = 'PageSize';

export default PageSize;
